import { CommonModule, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ContentDetailComponent } from '../content-detail/content-detail.component';
import { ContentListComponent } from '../content-list/content-list.component';

@Component({
  selector: 'career-content',
  standalone: true,
  imports: [NgIf, CommonModule, ContentListComponent, ContentDetailComponent],
  templateUrl: './content.component.html',
  styleUrl: './content.component.scss',
})
export class ContentComponent implements OnInit {
  jobId: string | null = null;
  hasJobId = false;

  ngOnInit() {
    this.jobId = this.parseJobIdFromPath(window.location.pathname);
    this.hasJobId = !!this.jobId;
  }

  private parseJobIdFromPath(path: string): string | null {
    const parts = path.split('/').filter(Boolean);

    if (parts[0] === 'allas' && parts.length >= 2) {
      return parts[1];
    }

    if (parts[0] === 'en' && parts[1] === 'job' && parts.length >= 3) {
      return parts[2];
    }

    return null;
  }
}
